export default __webpack_public_path__ + "static/media/step4-a.a0cddf74.png";